<template>
    <b-modal ref="addReminderModal" id="addReminderModal" size="lg"
             hide-footer centered title="Add Reminder">
        <b-form>
            <b-form-group
                    vertical
                    :label-cols="2"
                    breakpoint="lg"
                    label="Title"
                    label-for="">
                <b-input data-vv-scope="add_reminder" name="add_title" data-vv-as="Title" v-model="reminder.title" v-validate="'required'"></b-input>
                <span class="error">{{ errors.first('add_reminder.add_title') }}</span>
            </b-form-group>

            <b-form-group
                    vertical
                    :label-cols="2"
                    breakpoint="lg"
                    label="Date"
                    label-for="">
                <datepicker data-vv-scope="add_reminder" v-validate="'required'" data-vv-as="Reminder Date" name="add_reminder_date_time" format="yyyy-MM-dd" placeholder="yyyy-mm-dd" v-model="reminder.reminder_date_time"
                            :value="reminder.reminder_date_time" input-class="form-control"></datepicker>
                <span class="error">{{ errors.first('add_reminder.add_reminder_date_time') }}</span>
            </b-form-group>

            <b-form-group
                    vertical
                    :label-cols="2"
                    breakpoint="lg"
                    label="Notes"
                    label-for="">
                <b-form-textarea data-vv-scope="add_reminder" :rows="3" data-vv-as="Notes" v-validate="'required'" name="add_notes" v-model="reminder.notes"></b-form-textarea>
                <span class="error">{{ errors.first('add_reminder.add_notes') }}</span>
            </b-form-group>

            <b-row class="mt-5">
                <b-col col lg="12" md="12" sm="12" class="text-right">
                    <b-link @click="save"
                            class="btn btn-orange ">
                        <i class="dripicons-checkmark"></i> Save
                    </b-link>
                    <b-button @click="cancel"
                              class="btn btn-default">
                        <i class="dripicons-cross"></i> Cancel
                    </b-button>
                </b-col>
            </b-row>

        </b-form>
    </b-modal>
</template>

<script>
  import {mapActions} from 'vuex';
  import * as REMINDER from '@/store/constants/reminder';

  import Datepicker from 'vuejs-datepicker';

  // mixins
  import AuthUser from '@/mixins/authenticated-user';

  export default {
    inject: ['$validator'],
    props: {
      modalShow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        reminder: {}
      };
    },
    components: {Datepicker},
    mixins: [AuthUser],
    methods: {
      ...mapActions({
        addReminder: REMINDER.ACTION_ADD
      }),

      save() {
        this.reminder.status = 'pending';
        this.reminder.user_id = this.authUser.id;

        this.$validator.validate('add_reminder.*').then((valid) => {
          if (valid) {
            this.addReminder(this.reminder).then(() => {
              this.$refs['addReminderModal'].hide();
              this.$emit('saved', true);
              this.reminder = {};
            }).catch(err => console.log(err));
          }
        });
      },

      cancel() {
        this.$refs['addReminderModal'].hide();
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/views/Reminder/AddReminderFormModal.vue